import { render, staticRenderFns } from "./frontSolicitudContainer.vue?vue&type=template&id=27345121&"
import script from "./frontSolicitudContainer.vue?vue&type=script&lang=js&"
export * from "./frontSolicitudContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontSolicitudContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports